import { render } from "./InfoContactSettingDetail.vue?vue&type=template&id=ee94bda8"
import script from "./InfoContactSettingDetail.vue?vue&type=script&lang=js"
export * from "./InfoContactSettingDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__